<app-legacy-notification-preference
  [partnerId]="partnerId"
  [bulk]="true"
  (changes)="selectChange($event)"
></app-legacy-notification-preference>
